import { animate, style, transition, trigger } from "@angular/animations";
import { DynamicTabsService } from "../dynamic-tabs.service";

export interface INavbarData {
  id?:number;
  routerLink: string;
  icon?: string;
  label: string;
  expanded?: boolean;
  items?: INavbarData[];
  isVisible?:boolean;
  type?:string;
  onClick?:(dynamicTabsService:DynamicTabsService)=>void;
  }
export interface Tab{
    label: string; 
    routerLink: string; 
    isActive: boolean;
    closable: boolean;
    type:string;
  
  }
export interface INavbarDataItem 
{
  routerLink: string;
  name:string;
  label: string;
  tabName:string;
}
export interface Iclick{
  IsHomeClicked :boolean;
}

export class IHome {
  id!: number;
  accountID!: number;
  accountName!: string;
  policyType!: string;
  policyStatus!: string;
  contractNumber!: string;
  appID!: number;
  appNumber!: string;
  premium !: number;
  isDeleted!: boolean;
  created!: number;
  createdBy!: number;
  createdUser!: string;
  lastUpdated!: number;
  lastUpdatedBy!: number;
  lastUpdatedUser!: string;
  documentID!: number;
  organizationID!: number;
  masterPolicyNumber!: string;
  tLComboAdditionalInsured!: boolean;
  comboAccountID!: number;
  propertyLocation!: string;
  primaryTemplateID!: number;
  secondaryTemplateID!: number;
  hiddenFromCustomer!: boolean;
  renewalNoticeLastSent!: number;
  policySourceID!: number;
  fullyEndorsed!: boolean;
  propertyCity!: string;
  propertyCounty!: string;
  propertyStateID!: string;
  sourceID!: number;
  batchID !: number;
  batchType!: string;
  batchDescription!: string;
  isCertificateSent!: boolean;
  certificateSentDate!: number;
  certificateDeliveryTypeID!: number;
  masterPolicyID!: number;
  aMSPolicyGUID!: string;
  executiveName!: string;
  additionalInsuredRate!: number;
  applicationFee!: number;
  minimumPremiumCustom!: boolean;
  minimumPremiumScript!: string;
  appHLID!: number;
  eachOccurrence!: number;
  damageToRentedPremises!: number;
  notifiedOfExpiration!: boolean;
  source!: string;
  insuredCompanyName!: string;
  policyNumber!: string;
  policyTypeID!: number;
  policyStatusID!: number;
  contractID!: number;
  effectiveDate!: string;
  expirationDate!: string;
  acceptNewMemberPolicies!: boolean;
  acceptMemberPolicyRenewals!: boolean;
  insuredNameOnCertificate!: string;
  insuredValueRate!: string;
  minimumPremium!: number;
  notes!: string;
  damageToRentedPremisesExcluded!: boolean;
  medicalExpense!: number;
  medicalExpenseExcluded!: boolean;
  personalAdvertisingInjury!: number;
  personalAdvertisingInjuryExcluded!: boolean;
  generalAggregate!: number;
  productsCompletedOperationsAggregate!: number;
  productsCompletedOperationsAggregateExcluded!: boolean;
  renewalLetterReportName!: string;
  policyCoverageTypeID!: number;
  isImportFile_AFOA!: boolean;
  isNewBusiness!: boolean;
  priorPolicyID!: number;
  quoteID!: number;
  movedFromAccountID !: number;
  campNumber!: string;
  campName!: string;
  campLocation!: string;


}
export interface Idropdown {
  id: number,
  name: string
}
export interface Ipremiumtranscations {
  id:number;
  name: string;
  memberPolicyNumber: string,
  masterPolicyNumber: string,
  memberPolicyId: number,
  masterPolicyId: number,
  transactionId: number,
  transactionDate: number,
  transactionType: string,
  insuredValueChange: number,
  premiumChange: number,
}
export interface IabandonedApps {
  appId: number;
  accountId: number;
  startedDate: number;
  submittedDate: number;
  requestedEffectiveDate: number;
  descriptionOfOperations: string;
  yearsInOperation: number;
  priorExperience: string;
  emailAddress: string;
  mainNumber: string;
  mobileNumber: string;
  faxNumber: string;
  website: string;
  applicantName: string;
  contactName: string;
  address1: string;
  address2: string;
  city: string;
  stateId: number;
  abbr: string;
  postalCode: string;
  referralSourceId: number;
  referralSourceDetails: string;
  name: string;
  mainAppId: number;
}
export interface Iassociation {
  id: number;
 accountGuid: string;
 passwordResetGuid: string;
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  stateId: number;
  countryID: number;
  postalCode: string;
  email: string;
  password: string;
  homeNumber: string;
  workNumber: string;
  mobileNumber: string;
  isDeleted: boolean;
  created: number;
  createdBy: number;
  lastUpdated: number;
  lastUpdatedBy: number;
  lastLogin: number;
  billingName: string;
  billingAddress1: string;
  billingAddress2: string;
  billingCity: string;
  billingStateID: number;
  billingCountryID: number;
  billingPostalCode: string;
  organizationID: number;
  name: string;
  representativeName: string;
  memberCount: string;
  mainNumber: string;
  secondaryNumber: string;
  organizationMember: boolean;
  faxNumber: string;
  documentID: number;
  additionalInsured: boolean;
  membershipFee: number;
  mergedWithAccountID: number;
  paymentAccountID: string;
  x1: string;
  x2: string;
  x3: string;
  sourceID: number;
  batchID: number;
  batchType: string;
  batchDescription: string;
  membershipInfo: string;
  organizationMemberInfo: string;
  isCertificateSent: boolean;
  certificateSentDate: number;
  certificateDeliveryTypeID: number;
  masterAccountID: number;
  aMSCustomerGUID: string;
  mailCommunication: boolean;
  code: string;
  notes: string;
  elementPSAccountID: number;
  referred: boolean;
  referredBy: string;
  qDMAIsImported: boolean;
  qDMA_ProcessedDateTime: number;
  accountTypeID: number;
  referralSourceID: number;
  referralSourceDetails: string;
  campaignID: number;
  userSpecified: boolean;
  appID: number;
  websiteID: number;
  src_AccountId_AFOA: string;
  src_ChangedDate_AFOA: number;
  src_OwnedBy_AFOA: string;
}

export class IaddnewAssociations {
  name!: string;
  code!: string;
  createWebsite!: boolean;
  subDomain!: string;
  hlApp!: boolean;
  tlApp!: boolean;

  //association details
 accountID!: number;
 accountGuid!: string;
 passwordResetGuid!: string;
 firstName!: string;
 lastName!: string;
 address1!: string;
 address2!: string;
 city!: string;
 stateID!:number;
 countryID!:number;
 postalCode!: string;
 email!: string;
 password!: string;
 homeNumber!: string;
  workNumbe!: string;
 mobileNumbe!: string;
 isDeleted!:boolean;
 created!:number
 createdBy!:number;
 lastUpdated!:number
 lastUpdatedBy!:number
 lastLogin!:number;
 billingName!: string;
 billingAddress1!: string;
 billingAddress2!: string;
 billingCity!: string;
 billingStateID!:number;
 billingCountryID!:number;
 billingPostalCode!: string;
 organizationID!:number;
 accountName!: string;
 representativeName!: string;
 memberCount!: string;
 mainNumber!: string;
 secondaryNumber!: string;
 organizationMember!: boolean
 faxNumber!: string;
  documentID!:number
 additionalInsured!: boolean
 membershipFee!:number
 mergedWithAccountID!:number
 paymentAccountID!: string;
  X1!: string;
  X2!: string;
  X3!: string;
 sourceID!:number
 batchID!:number
 batchType!: string;
 batchDescription!: string;
 membershipInfo!: string;
  organizationMemberInfo!: string;
 isCertificateSent!: boolean
 certificateSentDate!:number
 certificateDeliveryTypeID!:number
 masterAccountID!:number
 aMSCustomerGUID!: string;
 mailCommunication!: boolean
 accountCode  !: string;      //Code
 notes!: string;
 elementPSAccountID!:number
 referred!: boolean
 referredBy!: string;
 qDMAIsImported!:number;
 qDMA_ProcessedDateTime!:number
 accountTypeID!:number
 referralSourceID!:number
 referralSourceDetails!: string;
 campaignID!:number
  UserSpecified!: boolean
 appID!:number
  websiteID!:number
  src_AccountId_AFOA!: string;
  src_ChangedDate_AFOA!:number
  src_OwnedBy_AFOA!: string;

  //AccountWebSettingsEntity
 iD!:number;
 id!:number;
 checkMailingName!: string;
 checkMailingAddressLine1!: string;
 checkMailingAddressLine2!: string;
 referralInformation!:boolean;
 referralQuestion!: string;
  //isDeleted  
  //public DateTime?created  
  //CreatedBy  
  //public DateTime? LastUpdated  
  //LastUpdatedBy  
  huntClubMembershipFee!: number;
  huntClubMembershipFeeCustom!: boolean;
  huntClubMembershipFeeScript!: string;
  landownerMembershipFee!: number;
  landownerMembershipFeeCustom!: boolean
  landownerMembershipFeeScript!: string;
  huntLeaseDisclaimer!: string;
  timberlandDisclaimer!: string;
  availableStates!: string;
  availableToQuickQuote!: boolean;
  memberBenefitsURL!: string;
  displayStandingTimberInfo!: boolean;
  displayPrescribedBuringInfo!: boolean;
  logoFileName!: string;
  url!: string;
  hLRenewalLetter!: string;
  TLRenewalLetter!: string;
  THRenewalLetter!: string;
  displayTimberlandFireCoverageInfo!: boolean;
  membershipVerificationEmailTo!: string;
  membershipFeesCollectedEmailTo!: string;
  landownerMemberAccounts!: boolean;
  offerLandownerMembership!: boolean;
  cLRenewalLetter!: string;
  blob1!: string;
  blob2!: string;
}
export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('350ms',
      style({ opacity: 1 })
    )
  ]),
  transition(':leave', [
    style({ opacity: 0 }),
    animate('350ms',
      style({ opacity: 1 })
    )
  ])
])



